<template>

  <div class="formulario">
    
        <b-card no-body>
          <div>
            <b-tabs content-class="mt-3" pills card @activate-tab="activateTabs">
              <b-tab title="Seleccione Emisor" :active="step === 0" @click.prevent="switchSteps(0)">
                <b-row>
                  <b-col>
                    <b-list-group v-for="(emisor, i) in emisores" :key="i">
                      <b-list-group-item href="#" class="mb-2" @click="stepServicios(emisor)">
                        <b-row align-v="center">
                          <b-col md="1">
                            <b-img left :src="require('../assets/'+emisor.logo)" style="max-width:60px;"></b-img>
                          </b-col>
                          <b-col>
                            <i class="fas fa-angle-right" style="font-size:20px;font-weight:bold;"> </i>
                            <span style="font-size:16px;font-weight:bold;">  {{ emisor.nombre_fantasia }}</span>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Seleccione el Servicio" :disabled="!servicios.length" :active="step === 1" @click.prevent="switchSteps(1)">
                <b-row>
                  <b-col>
                    <b-form-group id="IG_cuenta_origen" label="Seleccione una cuenta:" label-for="IF_cuenta_origen">
                      <b-form-select ref="select_co" v-model="item.cuenta_origen" :options="cuentas_origen" required />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-show="!campos.length">
                  <b-col>
                    <b-list-group v-for="(servicio, i) in servicios" :key="i">
                      <b-list-group-item href="#" class="mb-2" @click="getCampos(servicio)">
                        <b-row align-v="center">
                          <b-col>
                            <i class="fas fa-angle-right" style="font-size:20px;font-weight:bold;"> </i>
                            <span style="font-size:16px;font-weight:bold;">  {{ servicio.nombre }}</span>
                          </b-col>
                        </b-row>    
                      </b-list-group-item>
                    </b-list-group>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Consulta y/o Pago" :disabled="!campos.length" :active="step === 2" @click.prevent="switchSteps(2)">
                <b-form @submit.stop.prevent="handleSubmit" v-show="campos.length && !referencias.length" id="formConsulta" ref="formConsulta">
                  <InputPayment
                    v-for="campo in campos"
                    :key="campo.name"
                    v-bind="campo"
                  />
                  <b-row>
                    <b-col>
                      <b-button variant="outline-success" block type="submit">
                        <i class="fas fa-search"> </i>
                        {{ labelButton }}
                      </b-button>
                    </b-col>
                    <b-col>
                      <b-button variant="outline-danger" block @click.stop.prevent="resetVariables">
                        <i class="fas fa-window-close"> </i>
                        Cancelar
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
                
                <b-list-group v-for="(referencia, i) in referencias" :key="i"> 
                  <b-list-group-item href="#" class="mt-2 mb-2">
                    <b-row>
                      <b-col style="font-size:14px;font-weight:bold;" md="4">Descripción:</b-col>
                      <b-col>{{ referencia.descipcion }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col style="font-size:14px;font-weight:bold;" md="4">Referencia:</b-col>
                      <b-col>{{ referencia.referenciaPago }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col style="font-size:14px;font-weight:bold;" md="4">Monto:</b-col>
                      <b-col>{{ formatNumber(referencia.monto) }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col style="font-size:14px;font-weight:bold;" md="4">Acumulado:</b-col>
                      <b-col>{{ formatNumber(referencia.acumulado) }}</b-col>
                    </b-row>
                    <hr />
                    <div v-for="(meta, i) in referencia.hashMapContainer.map.entry" :key="i">
                      <b-row v-if="meta.value.visible == 'true'">
                        <b-col style="font-size:12px;font-weight:bold;" md="4">
                          {{ meta.value.legend }}
                        </b-col>
                        <b-col style="font-size:12px;">
                          {{ meta.value.value }} 
                        </b-col>
                      </b-row> 
                    </div>
                    <b-row class="mt-2">
                      <b-col></b-col>
                      <b-col md="6">
                        <b-button variant="outline-success" block @click="pagarConsulta(referencia)">
                          <i class="fas fa-wallet"> </i>
                          Pagar
                        </b-button>
                      </b-col>
                      <b-col></b-col>
                    </b-row>
                </b-list-group-item>
                </b-list-group> 
              </b-tab>
              <b-tab title="Ticket" :disabled="!ticket" :active="step === 3" @click.prevent="switchSteps(3)">
                <b-row>
                  <b-col></b-col>
                  <b-col>
                    <div class="ticket">
                      <span v-html="ticket"></span>
                    </div>
                  </b-col>
                  <b-col></b-col>
                </b-row>
                
              </b-tab>
            </b-tabs>
          </div>
        </b-card>

        <b-modal
          id="modal-pin-transaccional"
          ref="modal-pin-transaccional"
          title="PIN Transaccional"
          @show="resetModalPinTransaccional"
          @hidden="resetModalPinTransaccional"
          @ok="handleOkPinTransaccional"
          cancel-title="Cancelar"
          ok-title="Pagar"
        >
          <form ref="formPinTransaccional" @submit.stop.prevent="handleSubmitPinTransaccional">
            <b-form-group
              :state="nameState"
              label="Ingrese su PIN Transaccional"
              label-for="pin-transaccional"
              label-class="label-pin"
              invalid-feedback="Pin transaccional requerido."
            >
              <b-form-input
                class="input_clave"
                readonly
                id="pinTransaccional"
                ref="pinTransaccional"
                v-model="pin_transaccional"
                :state="nameState"
                type="password"
                minlength=6
                maxlength=6
                required
                autofocus
              ></b-form-input>
            </b-form-group>
            <b-row class="fila_numeros">
              <b-col><div class="boton_teclado" @click="oprimeTecla($event)">1</div></b-col>
              <b-col><div class="boton_teclado" @click="oprimeTecla($event)">2</div></b-col>
              <b-col><div class="boton_teclado" @click="oprimeTecla($event)">3</div></b-col>
            </b-row>
            <b-row class="fila_numeros">
              <b-col><div class="boton_teclado" @click="oprimeTecla($event)">4</div></b-col>
              <b-col><div class="boton_teclado" @click="oprimeTecla($event)">5</div></b-col>
              <b-col><div class="boton_teclado" @click="oprimeTecla($event)">6</div></b-col>
            </b-row>
            <b-row class="fila_numeros">
              <b-col><div class="boton_teclado" @click="oprimeTecla($event)">7</div></b-col>
              <b-col><div class="boton_teclado" @click="oprimeTecla($event)">8</div></b-col>
              <b-col><div class="boton_teclado" @click="oprimeTecla($event)">9</div></b-col>
            </b-row>
            <b-row class="fila_numeros">
              <b-col><div class="boton_teclado" @click="limpiarPIN" style="color:#890909;">
                <i class="fas fa-trash"> </i>
                </div></b-col>
              <b-col><div class="boton_teclado" @click="oprimeTecla($event)">0</div></b-col>
              <b-col><div class="boton_teclado" @click="borrarCaracter" style="color:#890909;">
                <i class="fas fa-angle-left"> </i> 
                </div></b-col>
            </b-row>
            
          </form>
        </b-modal>

  </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";

import InputPayment from "../components/InputPayment";

export default {
  name: 'pagarservicios',
  components: {
    InputPayment
  },
  data() {
    return {
      title: 'Pagar Servicios',
      item: {
        importe: null
      },
      step: 0,
      emisor: {},
      emisores: [],
      servicio: {},
      servicios: [],
      campos: [],
      originalResponse: {},
      referencias: [],
      ticket: null,
      item: {
        cuenta_origen: null
      },
      cuentas_origen: [],
      model: {
        emisor_codigo: null,
        referencia: null
      },
      labelButton: 'Consultar',
      consultas: [3,7],
      pin_transaccional: null,
      nameState: null,
      vue_app_imgpath: process.env.VUE_APP_IMGPATH 
    };
  },
  methods: {

    oprimeTecla(event) {
      if (this.pin_transaccional.length > 5) return
      this.pin_transaccional = `${this.pin_transaccional}${event.target.innerHTML}`;
    },

    borrarCaracter() {
      this.pin_transaccional = this.pin_transaccional.slice(0, -1);
    },

    limpiarPIN() {
      this.pin_transaccional = null;
    },

    checkFormValidity() {
      const valid = this.$refs.formPinTransaccional.checkValidity()
      this.nameState = valid
      return valid
    },

    resetModalPinTransaccional() {
      //this.pin_transaccional = null
      this.nameState = null
    },

    handleOkPinTransaccional(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmitPinTransaccional();
    },

    handleSubmitPinTransaccional() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-pin-transaccional')
        setTimeout(async () => {
          
          if (this.consultas.includes(this.servicio.operaciones)) {
            const respuestaPago = await this.sendPago();
            //(+respuestaPago.estado.codigoRetorno);
            if (+respuestaPago.estado.codigoRetorno === 0) {
              this.ticket = respuestaPago.ticket.replace(/\n/g, '<br/>');
              this.step = 3;
              this.resetVariables();
            } else {
              console.log('No es cero el codigo de retorno', +respuestaPago.estado.codigoRetorno);
              //this.showMessage('e-Coopex', respuestaPago.estado)
            }
          } else {
            const respuestaPago = await this.sendCobro();
            //console.log(+respuestaPago.estado.codigoRetorno);
            if (+respuestaPago.estado.codigoRetorno === 0) {
              this.ticket = respuestaPago.ticket.replace(/\n/g, '<br/>');
              this.step = 3;
              this.resetVariables();
            } else {
              console.log('No es cero el codigo de retorno', +respuestaPago.estado.codigoRetorno)
            }
          }
          
        }, 150);
      })
    },
    
    handleSubmit(e) {
      e.preventDefault();
      if (this.consultas.includes(this.servicio.operaciones)) {
        this.enviarConsulta();
      } else {
        this.enviarCobro();
      }
    },

    switchSteps(val) {
      switch (val) {
        case 0:
          //console.log('Emisores');
          break;

        case 1:
          //console.log('Servicios');
          break;

        case 2:
          //console.log('Consulta y/o Pago');
          break;
      
        default:
          //console.log('Default');
          break;
      }
    },
    
    activateTabs(newTabIndex, prevTabIndex, bvEvent) {
      
      if ( prevTabIndex === 1 && this.step === 2 && newTabIndex === 0 ) {
        bvEvent.preventDefault();
        return;
      }

      if ( prevTabIndex === 2 && this.step === 3 && newTabIndex === 0 ) {
        bvEvent.preventDefault();
        return;
      }

       //console.log('Previo:', prevTabIndex, 'Step:', this.step, 'Nuevo:', newTabIndex );

      // de consulta, vuelve a servicios
      if (newTabIndex === 1 && this.step === 2) {
        this.servicio = {};
        this.referencias = [];
        this.campos = [];
        this.step = 1;
      }

      // de servicios, vuelve a emisores
      if (newTabIndex === 0 && this.step === 1) {
        this.emisor = {};
        this.servicios = [];
        this.servicio = {};
        this.campos = [];
        this.referencias = [];
        this.model = {
          emisor_codigo: null,
          referencia: null
        };
        this.step = 0;
      }

      //de consulta, vuelve a emisores
      if (newTabIndex === 0 && this.step === 2) {
        this.emisor = {};
        this.servicios = [];
        this.servicio = {};
        this.campos = [];
        this.referencias = [];
        this.model = {
          emisor_codigo: null,
          referencia: null
        };
        this.step = 0;
      }

      //de consulta, vuelve a emisores
      if (newTabIndex === 0 && this.step === 3) {
        this.emisor = {};
        this.servicios = [];
        this.servicio = {};
        this.campos = [];
        this.referencias = [];
        this.model = {
          emisor_codigo: null,
          referencia: null
        };
        this.step = 0;
        this.ticket = null;
      }

    },
    
    showMessage(title, message, variant = 'danger', append = true) {
      this.counter++
      this.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-bottom-full',
        solid: true,
        variant: variant,
        appendToast: append,
        autoHideDelay: 5000
      })
    },
    
    formatNumber (n) {
      if ( n >= 0 ) {
        n = String(n).replace(/\D/g, "");
      } else {
        n = '-' + String(n).replace(/\D/g, "");
      }
      return n === '' ? n : Number(n).toLocaleString();
    },
    
    resetVariables() {
      this.emisor = {};
      this.servicios = [];
      this.servicio = {};
      this.campos = [];
      this.referencias = [];
      this.model = {
        emisor_codigo: null,
        referencia: null
      };
    },

    async enviarCobro() {
      this.pin_transaccional = null
      this.$bvModal.show('modal-pin-transaccional');
      setTimeout(() => {
        this.$refs.pinTransaccional.$el.focus();
      },150);
    },
    
    async enviarConsulta() {
      this.referencias = [];
      this.$refs['formConsulta'].elements.forEach(element => {
        if ( element.type == 'number' || element.type == 'text' ) {
          this.model[element.name] = element.value;
        }
      });
      
      if (this.model.tipodocumento) {
        this.model.referencia = `${this.model.tipodocumento};${this.model.referencia}`;
      }

      if (this.model.codigo_area) {
        this.model.referencia = `${this.model.codigo_area}${this.model.referencia}`;
      }

      if (this.servicio.emisor_codigo == 833) {
        this.model.referencia = `ISSAN;${this.model.referencia}`;
      }

      this.originalResponse =  await this.sendConsulta();
      //console.log(this.originalResponse);
      if ( this.originalResponse.codRetorno == 0 ) {
        if ( Array.isArray(this.originalResponse.detalleServicios.detalleReferencias) ) {
          this.referencias = this.originalResponse.detalleServicios.detalleReferencias;
        } else {
          this.referencias.push(this.originalResponse.detalleServicios.detalleReferencias);
        }
      } else {
        this.resetVariables();
        this.showMessage('e-Coopex', this.originalResponse.mensajeOperacion);
      }
    },
    
    async pagarConsulta(referencia) {
      this.$bvModal.show('modal-pin-transaccional');
      setTimeout(() => {
        this.$refs.pinTransaccional.$el.focus();
        // igual no cambio este tema del array o objeto, da lo mismo.
        this.originalResponse.detalleServicios.detalleReferencias = []
        this.originalResponse.detalleServicios.detalleReferencias[0] = referencia;
      },150);
    },

    async sendConsulta() {
      const loader = this.$loading.show();
      try {
         const body_enviado = {
           nro_socio: +window.localStorage.getItem("nro_socio"),
           servicio_id: this.servicio.id,
           model: this.model
         };
         const rows = await axios.post(`${process.env.VUE_APP_API_URL}/servicios/consulta`, body_enviado, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        })
        return rows.data
      } catch (err) {
        let message = err.message;
        if (err.response && err.response.data ) {
          message = err.response.data.message;
        } 
        this.showMessage('e-Coopex', message);
        return null
      } finally {
        loader.hide();
      }
    },

    async sendPago() {
      const loader = this.$loading.show();
      try {
         const body_enviado = {
           nro_socio: +window.localStorage.getItem("nro_socio"),
           nro_cuenta_origen: this.item.cuenta_origen,
           monto: this.originalResponse.detalleServicios.detalleReferencias[0].monto,
           consulta_id: this.originalResponse.consulta_id,
           servicio_id: this.servicio.id,
           referencia: this.model.referencia,
           referenciaPago: this.originalResponse
         };
         const rows = await axios.post(`${process.env.VUE_APP_API_URL}/servicios/pago`, body_enviado, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`,
            ControlKey: this.pin_transaccional+''
          }
        })
        return rows.data
      } catch (err) {
        let message = err.message;
        if (err.response && err.response.data ) {
          message = err.response.data.message;
        } 
        this.resetVariables();
        this.showMessage('e-Coopex', message);
        return { estado: { codigoRetorno: 1 } }
      } finally {
        loader.hide();
      }
    },

    async sendCobro() {
      this.referencias = [];
      this.$refs['formConsulta'].elements.forEach(element => {
        if ( element.type == 'number' || element.type == 'text' ) {
          this.model[element.name] = element.value;
        }
      });
      const loader = this.$loading.show();
      try {
        const body_enviado = {
           nro_socio: +window.localStorage.getItem("nro_socio"),
           nro_cuenta_origen: this.item.cuenta_origen,
           monto: this.model.monto,
           servicio_id: this.servicio.id,
           referencia: this.model.referencia,
           emisor_codigo: this.model.emisor_codigo
         };

        const rows = await axios.post(`${process.env.VUE_APP_API_URL}/servicios/cobro`, body_enviado, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`,
            ControlKey: this.pin_transaccional+''
          }
        })
        return rows.data;
      } catch (err) {
        let message = err.message;
        if (err.response && err.response.data ) {
          message = err.response.data.message;
        } 
        this.resetVariables();
        this.showMessage('e-Coopex', message);
        return { estado: { codigoRetorno: 1 } }
      } finally {
        loader.hide();
      }
    },

    async stepServicios(emisor) {
      //desplegamos todos los servicios de un emisor
      this.emisor = emisor;
      this.servicios =  await this.getServicios(emisor.id);
      this.step = 1;
    },
  
    async getCampos(servicio) {
      // controlamos que se seleccione una cuenta para continuar.
      if (!this.item.cuenta_origen) {
        this.showMessage('e-Coopex', `Seleccione una cuenta para pagar.`);
        this.$refs.select_co.$el.focus();
        return;
      }
      this.model['emisor_codigo'] = servicio.emisor_codigo;
      this.servicio = servicio;
      this.labelButton = this.consultas.includes(servicio.operaciones) ? 'Consultar' : 'Pagar';
      this.campos = servicio.formulario.campos;
      setTimeout(() => {
        this.step = 2;
      }, 200);
      
    },
    
    async getEmisores() {
      const loader = this.$loading.show();
      try {
         const rows = await axios.get(`${process.env.VUE_APP_API_URL}/servicios/emisores`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        })
        return rows.data
      } catch (error) {
         console.log(error.message)
      } finally {
        loader.hide();
      }
    },

    async getServicios(id) {
      const loader = this.$loading.show();
      try {
         const rows = await axios.get(`${process.env.VUE_APP_API_URL}/servicios/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        })
        return rows.data
      } catch (error) {
         console.log(error.message)
      } finally {
        loader.hide();
      }
    },

    async getCuentas() {
      const loader = this.$loading.show();
      try {
         const socio = await axios.post(`${process.env.VUE_APP_API_URL}/consulta/socio`, {
          socio_numero: +window.localStorage.getItem("nro_socio")
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        })
        return socio.data.cuentas
          .filter((cuenta) => cuenta.codigo_cuenta == "AH")
          .map((cuenta, i) => { return { value: cuenta.nro_cuenta, text: `${cuenta.nro_cuenta} | Saldo: ${ this.formatNumber(cuenta.saldo_cuenta) } Gs.` } });
      } catch (error) {
         console.log(error.message);
      } finally {
        loader.hide();
      } 
    },
  },
  async mounted() {
    this.emisores = await this.getEmisores();
    this.cuentas_origen = await this.getCuentas();
    if (!this.cuentas_origen) {
      this.cuentas_origen = [];
    }
    this.cuentas_origen.unshift( { value: null, text: `Seleccione una cuenta` } );
  }
};

</script> 

<style>
.formulario {
  margin: 2em;
  text-align: left;
  padding-top: 20px;
}
.ticket {
  font-family:'Courier New';
  font-size:14px;
  width:415px;
  border: 1.4px gray dashed; 
  padding:30px;
  border-radius:5px;
}
.boton_teclado {
  box-shadow:inset 0px 1px 0px 0px #ffffff;
	background:linear-gradient(to bottom, #ffffff 5%, #f6f6f6 100%);
	background-color:#ffffff;
	border-radius:5px;
	border:1px solid #dcdcdc;
	display:inline-block;
	cursor:pointer;
	color:#666666;
  align-items: center;
  text-align: center;
  padding: 5px;
  width: 50px;
  font-size: 18px;
  font-weight: bold;
  text-decoration:none;
	text-shadow:0px 1px 0px #ffffff;
}
.boton_teclado:hover {
  background:linear-gradient(to bottom, #f6f6f6 5%, #ffffff 100%);
	background-color:#f6f6f6;
}
.input_clave {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  width: 216px;
  margin-left: 120px;
  line-height: 30px;
  height: 32px;
  padding-top: 1px;
}
.fila_numeros {
  width:250px; 
  border: 0px solid black;
  margin-top: 5px;
  margin-left:105px;
}
.label-pin {
  display: block !important;
  margin-left: 125px !important;
}
</style>